<template>
  <CoverLayout>
    <div slot="content" class="buyVip">
      <div class="btnClose" @click="handleClose"></div>
      <div class="title">{{ title }}</div>
      <div class="subTitle">
        {{
          title === "查验他人"
            ? "您正在通过姓名、手机号向他人发起实名查验申请，本次查验他人服务付费标准如下："
            : "您正在生成溯源优才电子证书，本次生成电子证书服务付费标准如下："
        }}
      </div>
      <!-- <div class="vipBg"></div> -->
      <div class="ms_list">
        <div
          :class="`ms_item ${type === 0 && 'active'}`"
          @click="handleSelect(0)"
        >
          <div class="recommend">推荐</div>
          <div class="ms_topMb">
            <div>年费会员</div>
            <div class="price">
              ￥<span class="money" v-if="payInfo.annualFee">{{
                payInfo.annualFee / 100
              }}</span>
            </div>
          </div>
          <div class="ms_bottom">
            <div>可生成电子证书{{ payInfo.electronicCertificateTimes }}次</div>
            <div>查验他人{{ payInfo.inspectionTimes }}次</div>
            <div>设置默认查验应答</div>
            <div>批量处理查验应答</div>
          </div>
        </div>
        <div
          :class="`ms_item ${type === 1 && 'active'}`"
          @click="handleSelect(1)"
        >
          <div class="ms_top">
            <div>单次服务</div>
            <div class="price" v-if="payType === 'INSPECTION_SINGLE_PAYMENT'">
              ￥<span class="money" v-if="payInfo.inspectionSinglePayment">{{
                payInfo.inspectionSinglePayment / 100
              }}</span>
            </div>
            <div class="price" v-else>
              ￥<span
                class="money"
                v-if="payInfo.electronicCertificateSinglePayment"
                >{{ payInfo.electronicCertificateSinglePayment / 100 }}</span
              >
            </div>
          </div>
          <div class="ms_bottom">
            <div v-if="payType === 'INSPECTION_SINGLE_PAYMENT'">
              单次查验他人
            </div>
            <div v-else>单次生成证书</div>
          </div>
        </div>
      </div>
      <div style="padding-left:24px">
        <div class="payInfo">
          <div class="qrcode">
            <QRcode
              v-if="code_url"
              :QRlink="code_url"
              :qrwidth="210"
              :qrheight="210"
            />
          </div>

          <div class="payRight">
            <div>
              <div class="scanTip" style="">
                <i class="ico_wechat"></i>请使用<span class="wechatText"
                  >微信</span
                >扫码支付
              </div>
              <div>扫码支付完成后，请点击下方按钮，进入下一步。</div>
              <div class="yfText">应付金额：</div>
              <div v-if="type === 0">
                <span class="money" v-if="payInfo.annualFee"
                  >￥{{ payInfo.annualFee / 100 }}</span
                >/年
              </div>
              <div v-else>
                <span
                  class="money"
                  v-if="payType === 'INSPECTION_SINGLE_PAYMENT'"
                  >￥{{ payInfo.inspectionSinglePayment / 100 }}</span
                >
                <span class="money" v-else
                  >￥{{
                    payInfo.electronicCertificateSinglePayment / 100
                  }}</span
                >
                /次
              </div>
            </div>
            <div>
              <div class="qrtimeValid">
                二维码有效时长：<CountDown ref="countDown" />
              </div>
              <div class="refreshTip">
                如无法支付或者二维码已过期请点击<span
                  class="refresh"
                  @click="handleResetTimer"
                >
                  刷新</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="coverFooter"></slot>
      <!-- <div><Btn btnText="支付完成" className="primary" @handleClick="handleClick"/></div> -->
    </div>
  </CoverLayout>
</template>

<script>
import CountDown from "./CountDown.vue";
import CoverLayout from "./CoverLayout.vue";
import QRcode from "./QRcode.vue";
import { pay, payInfo } from "@/api/pay";
import Btn from "./Btn.vue";
export default {
  components: { CoverLayout, QRcode, CountDown, Btn },
  // props: ["payType"],
  props: {
    payType: {
      type: String
    },
    title: {
      type: String,
      default: "购买会员服务"
    },
    socketId: {
      type: String
    },
  },
  data() {
    return {
      type: 0,
      code_url: undefined,
      timerText: "09:59",
      timer: 600,
      price: "",
      payInfo: {}
    };
  },
  created() {
    this.handleRefresh();
  },
  methods: {
    getPayInfo() {
      payInfo().then(res => {
        this.price = res.data.d.annualFee;
        this.payInfo = res.data.d;
        if (this.payType === "ELECTRONIC_CERTIFICATE_SINGLE_PAYMENT") {
          this.price = res.data.d.electronicCertificateSinglePayment;
        }
        if (this.payType === "INSPECTION_SINGLE_PAYMENT") {
          this.price = res.data.d.inspectionSinglePayment;
        }
      });
    },
    handleSelect(type) {
      this.type = type;
      // this.price = type===0?69:1
      this.getPayInfo();
    },
    handleClose() {
      this.$emit("handleClose");
    },
    handleRefresh() {
      this.getPayInfo();
      console.log(this.socketId)
      pay({
        payType: this.type === 0 ? "ANNUAL_FEE" : this.payType,
        webSocketUserId: this.socketId
      }).then(res => {
        this.code_url = undefined;
        this.code_url = res.data.d.code_url;
      });
    },
    handleResetTimer() {
      this.$refs.countDown.handleReset();
      pay({
        payType: this.type === 0 ? "ANNUAL_FEE" : this.payType,
        webSocketUserId: this.socketId
      }).then(res => {
        this.code_url = undefined;
        this.code_url = res.data.d.code_url;
      });
    }
  },
  watch: {
    type(val) {
      this.handleResetTimer();
    }
  }
};
</script>

<style lang="scss" scoped>
.buyVip {
  z-index: 1;
  background: #fff;
  width: 731px;
  // padding: 44px 45px 68px 46px;
  padding: 45px;
  box-sizing: border-box;
  border-radius: 16px;
  position: relative;
  .btnClose {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 14px;
    height: 14px;
    cursor: pointer;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_close.png")
      no-repeat;
    background-size: cover;
  }
  .title {
    text-align: center;
    color: #653e12;
    font-size: 20px;
  }
  .subTitle {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    line-height: 24px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .vipBg {
    //   background: rgba(232, 177, 116, 0.53);
    background: linear-gradient(#e8b174, #ffffff);
    border-radius: 10px 10px 0 0;
    height: 179px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .coverFooter {
    width: 100%;
    text-align: center;
  }
}
.ms_list {
  display: flex;
  justify-content: space-around;
  margin-bottom: 32px;
  margin-top: 10px;
  .active {
    // box-shadow: 0px 0px 10px 0px #efdfca !important;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/payChecked.png")
      no-repeat;
    background-size: 40px 47px;
    background-position: 100% 100%;
    // width: 40px;
    // height: 47px;
    // .ms_top {
    //   background-color: #f9e5ce !important;
    //   background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/payMember_bg.png")
    //     no-repeat;
    //   background-size: 114px 126px;
    //   background-position: 100%;
    //   color: #885d22 !important;

    //   .price {
    //     color: #885d22;
    //     //   line-height: 50px;
    //     font-weight: 500;
    //     .money {
    //       font-size: 24px !important;
    //     }
    //   }
    // }
    // .ms_bottom {
    //   color: #b39164 !important;
    // }
  }
  .ms_item {
    width: 280.3px;
    box-shadow: 0px 0px 10px 0px #eeeeee;
    position: relative;
    border-radius: 10px;
    &:first-child {
      box-shadow: 0px 0px 10px 0px #efdfca !important;
      .ms_bottom {
        color: #b39164 !important;
      }
    }
    .recommend {
      position: absolute;
      left: 0;
      top: -9px;
      background: linear-gradient(43deg, #f06c30, #ff4734, #fe6151);
      width: 49px;
      height: 27px;
      border-radius: 8px 0px 8px 0px;
      color: #fff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .ms_topMb {
      height: 100px;
      display: flex;
      padding: 42px 0 22px 33px;
      box-sizing: border-box;
      justify-content: center;
      border-radius: 10px 10px 0px 0px;
      flex-direction: column;
      justify-content: center;
      font-size: 18px;
      color: #8d8d8d;
      background-color: #f9e5ce !important;
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/payMember_bg.png")
        no-repeat;
      background-size: 114px 126px;
      color: #885d22 !important;
      background-position: 100%;
      color: #885d22 !important;
    }
    .ms_top {
      height: 100px;
      display: flex;
      padding: 42px 0 22px 33px;
      box-sizing: border-box;
      justify-content: center;
      border-radius: 10px 10px 0px 0px;
      flex-direction: column;
      justify-content: center;
      background-color: #dadada;
      font-size: 18px;
      color: #8d8d8d;
      .price {
        line-height: 50px;
        .money {
          font-size: 24px;
        }
      }
    }
    .ms_bottom {
      padding: 23px 0 28px 28px;
      font-size: 14px;
      color: #aaaaaa;
      line-height: 30.5px;
    }
  }
}
.payInfo {
  display: flex;
  color: #6e6e6e;
  .payRight {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    line-height: 26px;
    .scanTip {
      display: flex;
      align-items: center;
      margin-right: 12px;
      font-size: 16px;
      // margin-bottom: 20px;
      margin-bottom: 5px;
      .ico_wechat {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ico_wechat.png")
          no-repeat;
        background-size: cover;
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }
    }
    .yfText {
      font-size: 18px;
      margin-bottom: 10px;
      margin-top: 20px;
    }
    .money {
      font-size: 32px;
      color: #ff5129;
    }
    .qrtimeValid {
      margin-bottom: 10px;
      .qrTimer {
        color: #ff5129;
      }
    }
    .refreshTip {
      .refresh {
        color: #47a2ff;
        cursor: pointer;
      }
    }
  }
  .qrcode {
    width: 210px;
    height: 210px;
    //   background: #000;
    margin-right: 37px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PayMember.vue